// Signaling is now handled by PeerJS Cloud (Free)
// No backend URL required.

export const ICE_SERVERS = {
  iceServers: [
    { urls: 'stun:stun.l.google.com:19302' },
    { urls: 'stun:global.stun.twilio.com:3478' }
  ],
};

// 16KB chunks are safe for WebRTC data channels
export const CHUNK_SIZE = 16384; 

export const COLORS = {
  primary: '#3b82f6', // blue-500
  success: '#22c55e', // green-500
  error: '#ef4444',   // red-500
  warning: '#eab308', // yellow-500
};